// Get the modal
if ($(window).width() < 768) {
$(".modal-var-content").hide();
}



if ($(window).width() > 769) {
  
  // When the user clicks the button, open the modal 
 $(document).on("click", "#custom-stitched", function(){  
  $('.standard-stiching-properties').hide();
  $('#myModal-popup').addClass('modal-varriant');
  $('.modal-wrapper').addClass('modal-var-content');
  $('.modal-wrapper .around-bust').removeClass('hidden');
  $(".modal-var-content").show();
 });

  
// When the user clicks on <span> (x), close the modal
   $(document).on("click", ".close", function(){
         $('#myModal-popup').removeClass('modal-varriant');
                  $('.modal-wrapper').removeClass('modal-var-content');
                  $('.modal-wrapper .around-bust').addClass('hidden');
                  $(".modal-var-content").hide();
           
        });
}

//how to measure imge hideshow
$(document).ready(function(){
  
  $(document).on("click", ".product-form__label", function(){
    if($(this).hasClass('custom-stitched')){
      $(".model-popup-container").show();
    }else{
        $('#tab-custom-stiching .mw-option-text').each(function(i) {
         $(this).find("input").val('');
        });
        $(".model-popup-container").hide();
    }
  });
  
  $(document).on("click", "#unstitched", function(){   
     $('.standard-stiching-properties').hide();
  });

    
  $(document).on("click", "#standard-stitching", function(){ 
    $('.standard-stiching-properties').show();
  });
  

  
  
  $('.mymultiplediv').mouseover(function() { 
    var myvar = this.id;
    $(".mydiv").hide();
    $('#div'+myvar).show();
  });


  /* enable blouse pads and select size of blouse pads */
   $('#blousepads-size-wrapper').hide();
    $(document).on("change", "select#blouse-pads", function(){ 
      var chnageIdx = parseInt($(this).find(':selected').attr('data-optindex'));
        if(chnageIdx == 2){
        $('#blousepads-size-wrapper').show();
        $('.product-form__submit').addClass('product-form__submit-blouse-pads');
      }else{
        $('.product-form__submit').removeClass('product-form__submit-blouse-pads');
        $("#blousepads-size-wrapper").val('');
        $('#blousepads-size-wrapper').hide();
      }
    });

    $(document).on("change", "select#blouse-pads-sizes", function(){
      var element = $("option:selected", this);
      var slecteedvar = element.attr("data-var-id");
      $('#bundle_blousepads_products').attr('data-varientid', slecteedvar);
    });

  /* end blouse pads product setting */

   /* enable petticoat */
  /*
    $(document).on("change", "select#petticoat", function(){
      var chnageIdx = parseInt($(this).find(':selected').attr('data-optindex'));
      if(chnageIdx == 2){
       var variant_petticoat = $('#bundle_petticoat_products').attr('data-varientid');
         $('.product-form__submit').addClass('product-form__submit-petticoat');
      }else{
         $('.product-form__submit').removeClass('product-form__submit-petticoat');
      }
    });
    */
/* end petticoat product setting */
  
  /* bundle product of petticoat and add bundle product of blouse pads */
    $(document).on("click", ".product-form__submit", function (e) {
      e.preventDefault();
      var bundleprdblousepads, bundleprdpetticoat;
      var enableblousepad = parseInt($("#blouse-pads").find(':selected').attr('data-optindex'));
      if(enableblousepad == 2){
          bundleprdblousepads = $('#bundle_blousepads_products').attr('data-varientid');
         //addItemToCart(bundleprdblousepads,1);
      }else{
        bundleprdblousepads = 0;
      }
      var enablepetticoat = parseInt($("#petticoat").find(':selected').attr('data-optindex'));
      if(enablepetticoat == 2){
          bundleprdpetticoat = $('#bundle_petticoat_products').attr('data-varientid');
         //addItemToCart(bundleprdpetticoat,1);
      }else{
        bundleprdpetticoat = 0;
      }
      addItemToCart(bundleprdblousepads,bundleprdpetticoat,1);
    });

});

Shopify.queue = [];  
  function addItemToCart(blouseprd,petticoatpro,qty) {
    
      Shopify.queue.push({
          variantId: blouseprd,
          quantity: qty
         });
    
      Shopify.queue.push({
          variantId: petticoatpro,
          quantity: qty
         });
    
      Shopify.addItem = function(id, qty, callback) {
         var params = {
            quantity: qty,
             id: id
          };
  $.ajax({
        type: 'POST',
       url: '/cart/add.js',
       dataType: 'json',
        data: params,
       success: function(data){
         if(typeof callback === 'function'){
           callback();
          }
         var product = data;
           document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this.addToCart
              }
            }));
        },
         error: function(XMLHttpRequest, textStatus, errorThrown) {
             console.log(XMLHttpRequest.responseText);
         }
      });
    }
   
    Shopify.moveAlong = function() {
      console.log(Shopify.queue);
      if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
        Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
      }
   };
   
  Shopify.moveAlong();
  }
